// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homeRow[data-v-4f03a0d7]{margin:auto;margin-top:10px;width:90%}.home[data-v-4f03a0d7]{border-radius:10px}.homeTabe[data-v-4f03a0d7]{max-width:1120px}@media screen and (max-width:600px){.homeTabe[data-v-4f03a0d7]{max-width:98%}}", ""]);
// Exports
module.exports = exports;
